module.exports = __webpack_public_path__ + "img/bos27.9aac672d.gif";